<template>
    <div>
        <a href="javascript:void(0);" @click="freeTry">免費體驗</a>
    </div>
</template>
<script>
  import "@/assets/css/w-style.css"

  import FreeTry from "@/components/common/FreeTry.vue"
  export default {
    components:{
        FreeTry
    },
    name: 'FreeTryButton',
    data(){
        return {
            freeTryVisible: false,
            edmFlag:""
        }
    },
    mounted() {
        this.getEDM()
    },
    created(){
        
    },
    methods: {
        getEDM() {
            let url = location.hash
            const paramsObj = {}
            // 参数匹配
            const PARAMS = url.match(/([^?&]+)=([^&]*)/g)
            // 参数缓存
            PARAMS &&
                PARAMS.reduce((params, item) => {
                // 符号`=`索引
                const index = item.indexOf('=')
                params[item.slice(0, index)] = item.slice(index + 1)
                return params
                }, paramsObj)

            this.edmFlag= decodeURIComponent(paramsObj.edm)
            console.log(this.edmFlag,'this.edmFlag')
            if(this.edmFlag==='free'){
                this.freeTry()
            }

        },
        freeTry() {
            this.freeTryVisible = true
            this.$emit("getFreeTryVisible",this.freeTryVisible)

            this.$http.post('/backend/web/record', {//免费体验点击次数埋点
                pageName: 'FreeTryClick',
                contentName : ''
            })
            .then(function (response) {
                if(response.status == 200){
                    console.log("success");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
        }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/common/FreeTryButton.vue